import { VentilationsState } from "../hooks/useVentilations";

export default (ventilations: VentilationsState["ventilations"]) => {
  return ventilations.filter(v => !!v.compte && !!v.montantCent);
};
